
import { makeStyles } from "@mui/styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { E3M3_TO_MCF, M3_TO_BBL } from "../../helpers/conversionFactors";
import { fbaConversionFactors } from "./fbaConversionFactors";

const useStyles = makeStyles({
  root: {
    background: 'transparent',
    border: 0,
    color: 'text.primary',
    height: 'auto',
    width: '100%',
    backgroundColor: 'transparent',
    // padding: '10px',
    overflow: 'hidden',
    // margin: 10
  },
  tableHeading: {
    marginLeft: 10,
    marginTop: 10,
  },
  table: {
    overflow: 'auto',
    minHeight: '100px',
    height: 700,
    marginTop: 30,
    marginBottom: 20,
  },
});

export const FBAProductionDataTable = ({ fbaData, units="metric" }) => {

  try {
    // STYLES
    const classes = useStyles();

    if (!fbaData || fbaData?.length === 0) return (<></>);

    const columns = [
      {
        field: 'date',
        headerName: 'Date',
        width: 175,
        type: 'string'
      },
      {
        field: 'days',
        headerName: 'Days',
        width: 125
      },
      {
        field: 'pwh',
        headerName: `Pwh (${units === 'metric' ? 'kPa' : 'psia'})`,
        width: 125
      },
      {
        field: 'oil',
        headerName: `Oil Rate (${units === 'metric' ? 'm3' : 'stb'}/d)`,
        width: 150
      },
      {
        field: 'condensate',
        headerName: `Cond. Rate (${units === 'metric' ? 'm3' : 'stb'}/d)`,
        width: 150
      },
      {
        field: 'gas',
        headerName: `Gas Rate (${units === 'metric' ? 'E3m3' : 'mscf'}/d)`,
        width: 150
      },
      {
        field: 'water',
        headerName: `Water Rate (${units === 'metric' ? 'm3' : 'stb'}/d)`,
        width: 150
      },
      {
        field: 'salinity',
        headerName: 'Salinity (ppm)',
        width: 150
      },
      {
        field: 'gor',
        headerName: `GOR (${units === 'metric' ? 'E3m3/m3' : 'scf/stb'})`,
        width: 150
      },
      {
        field: 'owr',
        headerName: `OWR (${units === 'metric' ? 'm3/m3' : 'stb/stb'})`,
        width: 150
      },
      {
        field: 'cgr',
        headerName: `CGR (${units === 'metric' ? 'm3/E3m3' : 'stb/scf'})`,
        width: 150
      },
    ];

    let rows = [];

    fbaData?.forEach((value, index) => {
      rows.push({
        id: index,
        date: (new Date(value?.date)?.toLocaleDateString() + ' ' + (new Date(value?.date)?.toLocaleTimeString()) || 0),
        days: (value?.days)?.toFixed(4) || 0,
        pwh: (units === 'metric' ? value?.pwh * fbaConversionFactors.pwh : value?.pwh)?.toFixed(1) || 0,
        oil: (units === 'metric' ? value?.oil / M3_TO_BBL : value?.oil)?.toFixed(1) || 0,
        condensate: (units === 'metric' ? value?.condensate / M3_TO_BBL : value?.condensate)?.toFixed(1) || 0,
        gas: (units === 'metric' ? value?.gas / E3M3_TO_MCF : value?.gas)?.toFixed(1) || 0,
        water: ((units === 'metric' ? value?.water / M3_TO_BBL : value?.water))?.toFixed(1) || 0,
        salinity: (value?.salinity) || 0,
        gor: (units === 'metric' ? value?.gor * fbaConversionFactors.gor : value?.gor)?.toFixed(1) || 0,
        owr: (value?.owr)?.toFixed(3) || 0,
        cgr: (units === 'metric' ? value?.cgr * fbaConversionFactors.cgr : value?.cgr)?.toFixed(1) || 0,
      });
    });

    return (
      <div className={classes.root}>
        <DataGrid
          rows={rows}
          columns={columns}
          rowsPerPageOptions={[10,25,50,100]}
          disableSelectionOnClick
          className={classes.table}
          components={{
            Toolbar: GridToolbar,
          }}
          density="compact"
          style={{fontSize: 12}}
        />
      </div>
    );
  } catch (error) {
    return <></>
  };
};
